import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getShoolLunches } from "../services/school-lunch";

export function useSchoolLunch({
  year,
  week,
  city,
}: {
  year: number;
  week: number;
  city: string;
}) {
  return useQuery({
    queryKey: ["school-lunch", year, week, city],
    queryFn: () => getShoolLunches({ year, week, city }),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
